export default function (json) {
  this.id = json.id
  this.city = json.city
  this.state = json.state
  this.country = json.country
}